import React, { useContext, useEffect, useState } from 'react';
import CommonImage, { ImageType } from '../CommonImage';
import cx from 'classnames';
import { useTranslations } from 'next-intl';
import { pagePathUrl } from '@/constants/url';
import HomeLogo from '../HomeLogo';
import CommonHeaderM from '../CommonHeaderM';
import { loginOut, ACCOUNT_ROLE, IUserLoginInfo, userSign } from '@/api/user';
import { ITopLevelNav } from '@/api/nav';
import { getCheckInResult } from '@/api/checkIn';
// import { getTopLevelNavPageUrl, getSecondLevelNavPageUrl } from '@/constants/url';
import { oldUserCenterUrl, getTopLevelNavPageUrl, getSecondLevelNavPageUrl } from '@/constants/url';

import userCenter from '@/constants/userCenter';
import SearchModal from '../SearchModal';
import CheckInModal from '../CheckInModal';
import { formatPromptMsgNumber } from '@/utils/formatNumber';
import Styles from './index.module.scss';
import { ActionTypeValues, StoreContext, namespace } from '@/context';
import useLoginAuth from '@/hooks/useLoginAuth';
import errorCode from '@/constants/errorCode';
import { PromiseState } from '@/constants';
import Toast from '@/components/Toast';
import CommonIcon from '@/components/CommonIcon';
import AddPost from '../../assets/icon/homeSidebar/add-post.svg';
import Button from '../CommonButton';
import useCheckLoginState from '@/hooks/useCheckLoginState';
import Tooltip from '../CustomTooltip';
import { useRouter } from 'next/router';
import SignInTooltip from '../SignInTooltip';

const userActiveLogo = `${process.env.RESOURCE_URL}uc_server/images/noavatar_middle.gif`;

interface IConfig {
  key: string;
  text: string;
  isLink: boolean;
  url?: string;
  openName?: string;
  sensorName?: string;
}

const unLoginConfig: IConfig[] = [{
  key: 'login',
  text: '登录',
  isLink: true,
  openName: '_blank',
  url: userCenter().login,
  sensorName: 'login_button_click',
}, {
  key: 'register',
  text: '注册',
  isLink: true,
  openName: '_blank',
  url: userCenter().register,
  sensorName: 'login_button_click',
}]

const config: IConfig[] = [{
  key: 'userCenter',
  text: "个人中心",
  isLink: true,
  openName: '_blank',
  url: '/pro/user-center',
  sensorName: 'account_bar_button_click',
}, {
  key: 'remind',
  text: "消息",
  isLink: true,
  openName: '_blank',
  url: '/pro/user-center?do=mynotice',
  sensorName: 'account_bar_button_click',
}, {
  key: 'collect',
  text: "收藏",
  isLink: true,
  openName: '_blank',
  url: '/pro/user-center?do=favorite&view=me',
  sensorName: 'account_bar_button_click',
}, {
  key: 'setting',
  text: "修改资料",
  isLink: true,
  openName: '_self',
  url: '/pro/user-center?ac=setting',
  sensorName: 'account_bar_button_click',
}, {
  key: 'signOut',
  text: "退出",
  isLink: false,
  sensorName: 'account_bar_button_click',
}];

const adminPermissions: IConfig[] = [{
  key: 'moduleManagement',
  text: "模块管理",
  isLink: true,
  openName: '_blank',
  url: '/portal.php?mod=portalcp',
}, {
  key: 'cloudPlatform',
  text: "云平台",
  isLink: true,
  openName: '_blank',
  url: '/admin.php?frames=yes&action=cloud&operation=applist'
}, {
  key: 'managementCenter',
  text: "管理中心",
  isLink: true,
  openName: '_blank',
  url: '/admin.php'
}, {
  key: 'stat',
  text: "站点统计",
  isLink: true,
  openName: '_blank',
  url: '/misc.php?mod=stat'
}];

// 模块管理  portal.php?mod=portalcp
// 模块管理 forum_manager   /pro/detail?mod=modcp&fid=$_G[fid] // 版主
// 云平台 admin.php?frames=yes&action=cloud&operation=applist
// 管理中心 admin.php
// 站点统计 misc.php?mod=stat
interface ICommonHeader {
  fid?: number;
  account: IUserLoginInfo;
  navsList?: ITopLevelNav[];
  hasNav?: boolean;
  saltkey?: string;
  onCreditsChange?: (credits: number) => void;
}
const CommonHeader = ({
  fid,
  saltkey,
  navsList = [],
  hasNav = false,
  onCreditsChange,
}: ICommonHeader) => {
  const { pathname } = useRouter();
  // const router = useRouter();
  // const { pathname } = router;
  const { isLogout, hadLoginState } = useCheckLoginState();
  const { state, dispatch } = useContext(StoreContext);

  const { account, permission } = state[namespace.app];
  const { track, TRACK_EVENTS } = state[namespace.app].sensors || {};

  const [isShowUserDropdown, setIsShowUserDropdown] = useState(false);
  const [isShowSearchModal, setIsShowSearchModal] = useState(pathname.includes('search') ? true : false);
  // 刚进入搜索页时，不显示推荐弹窗,清空搜索框一次之后显示(这个状态放在父组件来保存,因为SearchModal组件每次关闭都会销毁)
  const [isShowSearchPush, setIsShowSearchPush] = useState(!pathname.includes('search'));
  const [isShowCheckInModal, setIsShowCheckInModal] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isDuplicateCheck, setIsDuplicateCheck] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const t = useTranslations();
  const { isLogin } = useLoginAuth(account);

  useEffect(() => {
    if (!pathname.includes('search') && isShowSearchModal) {
      // 从搜索结果页离开后，关闭搜索框
      setIsShowSearchModal(false);
    }
  }, [pathname])

  const renderNav = () => {
    return navsList.map(({ title, link_url: url, open_type: openType }, navIndex)=>{
      return (
        <div
          key={url}
          className={Styles.navItemWrapper}
        >
          <a
            href={url}
            target={openType === 1 ? '_blank' : '_self'}
            className={cx(Styles.topLevelItem, (url.includes(pathname) || pathname.includes('home') && title === '首页') ? Styles.activeNav : '')}
            onClick={() => {
              track?.(TRACK_EVENTS?.[namespace.detail].selectTopListClick.name, {
                button_name: title,
              }, namespace.detail);
            }}
          >
            { title }
          </a>
        </div>
      )
    });
  }
  const renderHeaderLeft = () => (
    <div className={cx(Styles.headerLeft, {[Styles.headerLeftOther]: hasNav})}>
      <HomeLogo isMobile={false} />
      {
        isShowSearchModal ? (
          <SearchModal isShow={isShowSearchModal} isShowSearchPush={isShowSearchPush} onClose={onHideSearchModal} />
        ) : (
          hasNav ?
          <div className={Styles.topLevelNav}>
            { renderNav() }
          </div> :
          <>
            <span className={Styles.line}></span>
            <span className={Styles.secondaryTitle}>发表帖子</span>
          </>
        )
      }
    </div>
  );

  const checkInStatusHandler = () => {
    getCheckInResult().then((res) => {
      setIsChecked(res.signed);
      setIsDuplicateCheck(res.signed);
    });
  }

  useEffect(() => {
    checkInStatusHandler();
  }, []);

  const onMouseOver = () => {
    setIsShowUserDropdown(true)
  };

  const onMouseLeave = () => {
    setIsShowUserDropdown(false)
  };

  const onClickUserAction = (configItem:IConfig) => {
    if(configItem?.sensorName) {
      track?.(TRACK_EVENTS?.[namespace.home].accountBarButtonClick.name, {
        button_name: configItem.text,
        position: 'Top',
      }, namespace.home);
    }

    if(configItem.isLink) {
      if (configItem.key === 'userCenter') {
        account && window.open(oldUserCenterUrl({uid: account.id, uuid: account.uuid}), configItem.openName);
        // router.push(pagePathUrl.userCenter);
        return;
      }
      window.open(configItem.url, configItem.openName);
    } else if (configItem.key === 'signOut') {
      loginOut().then(()=>{
        dispatch({
          namespace: namespace.app,
          type: ActionTypeValues.CLEAR_ACCOUNT
        })
        const redirectPaths = ['/pro/edit', '/pro/message', '/pro/points'];
        if (redirectPaths.some(path => window.location.pathname.startsWith(path))) {
          window.location.href = '/';
        } else {
          window.location.reload();
        }
      })
    }
  };

  const handleConfig = () => {
    // 未登录
    if(!isLogin) {
      return unLoginConfig;
    } else if (account?.role === ACCOUNT_ROLE.ADMIN || (account?.role === ACCOUNT_ROLE.FORUM_ADMIN)) {
      const lastSignOut = config.slice(4, 5);
      return config.slice(0,4).concat(adminPermissions).concat(lastSignOut);
    }
    return config;
  };

  const onClickAvatar = () => {
    track?.(TRACK_EVENTS?.[namespace.home].accountBarButtonClick.name, {
      button_name: 'MyProfile',
      position: 'Top',
    }, namespace.home);
    if (isLogin) {
      account && window.open(oldUserCenterUrl({uid: account.id, uuid: account.uuid}));
      // router.push(pagePathUrl.userCenter);
    }
  };

  const renderUser = () => {
    const _dom = (
      <div className={Styles.userWrapper} onMouseOver={onMouseOver} onMouseLeave={onMouseLeave} key="userInfo">
        <div onClick={onClickAvatar} className={cx(Styles.userImageWrapper, {[Styles.loginUserImageWrapper]: isLogin})}>
          <div className={Styles.avatar}>
            <CommonImage
              src={account?.avatar?.medium || userActiveLogo}
              layout={[32, 32]}
              cutMode='cover'
              type={ImageType.avatar}
            />
          </div>
          {
            account && account?.messages > 0 && <span className={cx(Styles.msg, { [Styles.msgMax]: account.messages > 99})}>{formatPromptMsgNumber(account.messages)}</span>
          }
        </div>
        <ul className={cx(Styles.userList, {[Styles.userListShow]: isShowUserDropdown})} onMouseOver={onMouseOver} onMouseLeave={onMouseLeave}>
          {handleConfig().map((configItem)=>{
            return (
              <li
                key={configItem.key}
                onClick={() => onClickUserAction(configItem)}
              >
                {configItem.text} {configItem.key === 'remind' && account && account?.messages > 0 ? <span
                  className={cx(Styles.msg, { [Styles.msgMax]: account.messages > 99})}
                >
                  {formatPromptMsgNumber(account.messages)}
                </span> : ''}
              </li>
            )
          })}
        </ul>
      </div>
    );
    return _dom;
  };

  const onShowSearchModal = () => {
    track?.(TRACK_EVENTS?.[namespace.detail].searchFunctionClick.name, {}, namespace.detail);
    setIsShowSearchModal(true);
  };

  const onHideSearchModal = () => {
    setIsShowSearchModal(false);
    setIsShowSearchPush(true);
  };

  const renderSearch = () => {
    if (isShowSearchModal) return <></>;
    return (
        <Tooltip
          key="search"
          placement='bottom'
          title={t("btn_search")}
        >  
          <div className={Styles.searchIconWrapper} onClick={onShowSearchModal}>
            <CommonIcon
              icon="header-search"
              className={Styles.icon}
            />
          </div>
        </Tooltip>
    )
  };

  const onCheckIn = () => {
    if (!isLogin) {
      window.location.href = userCenter().login;
      return;
    };

    if (isChecked) {
      setIsShowCheckInModal(true);
      setIsDuplicateCheck(true);
      return;
    }


    userSign().then(res => {
      if (res.success) {
        setIsChecked(true);
        track?.(TRACK_EVENTS?.[namespace.detail].checkIn.name, {}, namespace.detail);
        setTooltipVisible(true);
        if (typeof res?.credits === "number") {
          onCreditsChange?.(res.credits);
        }
        setTimeout(() => {
          setTooltipVisible(false);
        }, 5000);
      }
    }).catch((e) => {
      Toast.show({
        content: e?.message || '签到失败'
      });
    });
  };

  const onHideCheckInModal = () => {
    setIsShowCheckInModal(false);
  };

  const handlePublish = () => {
    if (permission?.status !== PromiseState.PENDING) {
      if (permission?.code === errorCode.UNBIND_PHONE) {
        // 未绑定手机号
        Toast.show({
          content: permission?.message || t('phone_number_is_not_bound_tip'),
        });
        setTimeout(() => {
          window.open(`${process.env.SITE_ORIGIN}${pagePathUrl.edit}`, "_blank");
        }, 1e3)
        track?.(TRACK_EVENTS?.[namespace.detail].uploadButtonsClick.name, {
          position: 'Top',
          is_success: false,
          fail_reason: '未绑定手机号',
        }, namespace.detail);
      } else {
        // 成功/未登录
        window.open(`${process.env.SITE_ORIGIN}${pagePathUrl.edit}`, "_blank");
        track?.(TRACK_EVENTS?.[namespace.detail].uploadButtonsClick.name, {
          position: 'Top',
          is_success: isLogin,
          fail_reason: isLogin ? '' : '未登录',
        }, namespace.detail);
      }
    } else {
      // pending
      track?.(TRACK_EVENTS?.[namespace.detail].uploadButtonsClick.name, {
        position: 'Top',
        is_success: false,
        fail_reason: '权限校验暂未通过',
      }, namespace.detail);
    }
  }

  const renderCheckIn = () => {
    if (isChecked) {
      return (
        <div className={Styles.signContent}>
          <div className={Styles.signedText}>已签到</div>
          <SignInTooltip className={Styles.signTooltip} message="签到成功！积分+2" visible={tooltipVisible} />
        </div>
      )
    }
    return (
      <Tooltip
        key="checkInBtn"
        placement='bottom'
        title={t("tips_check_in")}
      >  
        <div
          key="checkInBtn"
          onClick={onCheckIn}
          className={Styles.checkInIconWrapper}
        >
          <div className={isChecked ? Styles.checkInActiveIcon : Styles.checkInIcon} />
        </div>
      </Tooltip>
    );
  }

  const renderPublishBtn = () => {
    return (
      <Tooltip key="publish" placement='bottom' title={t("btn_publish_topic")}>  
        <div className={Styles.addPost} onClick={handlePublish}>
          <AddPost />
        </div>
      </Tooltip>
    );
  }

  const renderLoginBtn = () => {

    return (
      <div
        key="login"
        className={Styles.loginBtnDefault}
      >
        <Button
          text='登录'
          onClick={() => {
            track?.(TRACK_EVENTS?.[namespace.home].loginButtonClick.name, {
              position: 'Top'
            }, namespace.home);
            window.open(userCenter().login, 'blank');
          }}
          className={Styles.loginButton}
        />
      </div>
    );
  }

  const renderHeaderExtraActions = () => {
    // 获取登录信息接口已完成，且确认为未登录
    const logout = hadLoginState && isLogout;
    // 获取登录信息接口完成，且确认已登录
    const login = hadLoginState && isLogout !== null && !isLogout;
    let res: React.ReactElement[] = [];

    if (hasNav) { // 有导航的Header
      res = [renderSearch(), renderCheckIn(), renderPublishBtn()];

      if (logout) {
        res.push(renderLoginBtn());
      } else if (login) {
        res.push(renderUser());
      } else {
        res.push(
          <div key="defaultLoading" className={Styles.loginBtnDefault}>
            <div className={Styles.loginButtonLoading} />
          </div>
        );
      }
    } else { // 不需要导航的Header
      res = login
        ? [renderUser()]
        : [
            <div key="defaultLoading" className={Styles.loginBtnDefault}>
              <div className={Styles.loginButtonLoading} />
            </div>,
          ];
    }
    return res;
  };

  return (
    <section className={Styles.header}>
      <div className={Styles.headerWrapper}>
        <CommonHeaderM
          className={Styles.headerContent}
          renderLeft={renderHeaderLeft}
          renderExtra={renderHeaderExtraActions}
        />
      </div>
      { isShowCheckInModal && <CheckInModal isChecked={isDuplicateCheck} onClose={onHideCheckInModal} />}
    </section>
  )
}

export default CommonHeader
